/*
 * Copyright (c) 2022.
 * This file is part of the Compo B2B application.
 * (c) Compo soft - Dmitri Puscas
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import {Injectable} from '@angular/core';
import {BaseService} from './base.service';
import {CompoApiService} from './compo-api.service';
import {Observable} from 'rxjs';
import {ApiResponse} from '../interfaces/ApiResponse';
import {catchError} from 'rxjs/operators';
import { HttpParams } from '@angular/common/http';
import { PageApiResponse } from '../interfaces/PageApiResponse';
import { NotificationCustomer } from '../interfaces/NotificationCustomer';


@Injectable({
  providedIn: 'root'
})

export class NotificationCustomerService extends BaseService {
  constructor(private readonly apiService: CompoApiService) {
    super();
  }

  filter(params: HttpParams): Observable<ApiResponse<PageApiResponse<NotificationCustomer[]>>> {
    return this.apiService.getWithParams<PageApiResponse<NotificationCustomer[]>>('/notification-customer/filter', params).pipe(catchError(err => this.handleError(err)));
  }

  get(id: number): Observable<ApiResponse<string>> {
    return this.apiService.get<string>('/notification-customer/' + id);
  }

}
